import * as angular from 'angular';
import { config } from 'angular/utils/config';

export interface UploadReportResource extends ng.resource.IResourceClass<
    ng.resource.IResource<any>
> {
    get: ng.resource.IResourceMethod<ng.resource.IResource<UploadReportDto>>;
    getMatching: ng.resource.IResourceMethod<
        ng.resource.IResource<UploadReportMatchingDto>
    >;
    getAdditionalAuctionInformation: ng.resource.IResourceMethod<
        ng.resource.IResource<any>
    >;
    edit: ng.resource.IResourceMethod<ng.resource.IResource<any>>;
    cancel: ng.resource.IResourceMethod<ng.resource.IResource<any>>;
    report: ng.resource.IResourceMethod<
        ng.resource.IResource<DataPageDto<UploadReportDto>>
    >;
}

function uploadReportResource(
    $resource: ng.resource.IResourceService
): UploadReportResource {
    return <UploadReportResource>$resource(
        config.monolithApi + '/uploads',
        {},
        {
            get: {
                method: 'GET',
                url: config.monolithApi + '/uploads/:rawDataId'
            },
            getAdditionalAuctionInformation: {
                method: 'GET',
                url:
                    config.monolithApi +
                    '/uploads/additionalAuctionInformation/:rawDataId',
                isArray: true
            },
            getMatching: {
                method: 'GET',
                url: config.monolithApi + '/uploads/matching/:auctionId',
                isArray: true
            },
            cancel: {
                method: 'POST',
                url: config.monolithApi + '/uploads/:rawDataId/cancel',
                params: {
                    rawDataId: '@rawDataId'
                }
            },
            edit: {
                method: 'GET',
                url:
                    config.monolithApi +
                    '/product-upload/product-edit/:rawDataId'
            },
            report: {
                method: 'GET',
                url: config.monolithApi + '/uploads/report'
            }
        }
    );
}

angular.module('app').factory('uploadReportResource', uploadReportResource);
